import { useForm } from "react-hook-form";
import { Col, Row } from "antd";

import { Container, CardLogin } from "../Login/styles";
import Field from "ui/components/Input/Field";
import { Button, Box } from "@chakra-ui/react";

import { getFirestore, collection, addDoc } from "firebase/firestore";
import { signInAnonymously, getAuth } from "firebase/auth";

import { useState, useEffect } from "react";
import { QRCodeCanvas } from "qrcode.react";

function RegisterParticipantePage() {
  const { control, handleSubmit, reset } = useForm<{
    nome: any;
    celular: any;
  }>({
    reValidateMode: "onChange",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [urlFull, setUrlFull] = useState("");

  useEffect(() => {
    const auth = getAuth();

    signInAnonymously(auth);
  }, []);

  const handleRegister = async (values: any) => {
    setIsLoading(true);

    setUrlFull("");

    const firestore = getFirestore();

    const codigo = (Math.random() + 1).toString(36).substring(7);

    const url = `https://connect-mind.com/confirmacao/${codigo}`;

    try {
      await addDoc(collection(firestore, "inscricoes"), {
        createdAt: new Date(),
        celular: values.celular?.replace(/[^0-9]/, "") ?? null,
        nome: values.nome,
        codigo,
      });

      reset();

      setUrlFull(url);
    } catch (err: any) {
      alert(err.message);
    } finally {
      setIsLoading(false);
    }
  };

  function download() {
    var canvas: any = document.getElementById("canvas");
    var url = canvas.toDataURL("image/png");
    var link = document.createElement("a");
    link.download = "qrcode.png";
    link.href = url;
    link.click();
  }
  return (
    <Container>
      <CardLogin>
        <form onSubmit={(ev) => handleSubmit(handleRegister)(ev)}>
          {!urlFull ? (
            <Row gutter={16}>
              <Col sm={24}>
                <Field
                  label="Nome"
                  control={control}
                  name="nome"
                  rules={{
                    required: {
                      message: "Informe seu nome",
                      value: true,
                    },
                  }}
                />
              </Col>
            </Row>
          ) : null}

          {!urlFull ? <br /> : null}

          {!urlFull ? (
            <Row gutter={16}>
              <Col sm={24}>
                <Field label="Celular" control={control} name="celular" />
              </Col>
            </Row>
          ) : null}

          {!urlFull ? <br /> : null}

          {!urlFull ? (
            <div>
              <Button
                isLoading={isLoading}
                disabled={isLoading}
                type="submit"
                isFullWidth
              >
                {isLoading ? "Cadastrando..." : "Cadastrar"}
              </Button>
            </div>
          ) : null}

          {urlFull ? (
            <div>
              <Button
                isLoading={isLoading}
                disabled={isLoading}
                type="button"
                onClick={() => setUrlFull("")}
                isFullWidth
              >
                Cadastrar outro participante
              </Button>
            </div>
          ) : null}

          {urlFull ? (
            <Box>
              <Box my="32px" p="16px" bg="blackAlpha.900" color="white">
                {urlFull}
              </Box>

              <Box
                bg="blue.500"
                py="8px"
                alignItems={"center"}
                justifyContent={"center"}
                d="flex"
              >
                <QRCodeCanvas
                  value={urlFull}
                  bgColor="transparent"
                  fgColor="white"
                  id="canvas"
                />

                <Button onClick={() => download()} ml={10}>
                  Baixar
                </Button>
              </Box>
            </Box>
          ) : null}
        </form>
      </CardLogin>
    </Container>
  );
}

export default RegisterParticipantePage;
